import React, { useState, useEffect } from 'react';

const OfflineStatusBanner = () => {
  const [isOnline, setIsOnline] = useState(navigator.onLine);

  useEffect(() => {
    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  if (isOnline) return null;

  return (
    <div className="bg-amber-500 px-3 sm:px-4 py-2 text-center">
      <div className="max-w-7xl mx-auto flex items-center justify-center text-xs sm:text-sm text-white">
        <span className="inline-block w-1.5 h-1.5 sm:w-2 sm:h-2 bg-red-600 rounded-full mr-2"></span>
        You are currently offline. Some features may be limited.
      </div>
    </div>
  );
};

export default OfflineStatusBanner; 